module.exports = __webpack_public_path__ + "img/file-pdf.6bb6005b.svg";